import React from 'react';

const STATS = [
  { value: '500+', label: 'Organizations served' },
  { value: '98%', label: 'Request resolution rate' },
  { value: '24h', label: 'Average response time' },
  { value: '99.9%', label: 'Platform uptime SLA' },
];

const GuestStats = () => (
  <section className="py-16 bg-white border-t border-b border-[#919191]/20">
    <div className="max-w-screen-2xl mx-auto px-10">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-10 text-center">
        {STATS.map((s) => (
          <div key={s.label}>
            <div className="text-5xl font-extrabold text-[#53545a] tracking-tight">{s.value}</div>
            <p className="text-[#919191] mt-2 text-sm">{s.label}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default GuestStats;
